import React, { useEffect, useState } from 'react';
import PerimetreSelector from '../PerimetreSelector/PerimetreSelector';
import type { PerimetreValue } from '../PerimetreSelector/PerimetreSelector';
import './PerimetreCarteModal.css';

interface PerimetreCarteModalProps {
  isOpen: boolean;
  onClose: () => void;
  initialValue: PerimetreValue;
  saving?: boolean;
  onValidate: (value: PerimetreValue) => void;
}

/**
 * Modale d'edition du perimetre geographique d'achat via la CARTE (PerimetreSelector).
 * Ouverte depuis le tableau de localisation : valider met a jour le perimetre de
 * l'organisme, et le tableau (dont les zones derivent du perimetre) se rafraichit.
 */
const PerimetreCarteModal: React.FC<PerimetreCarteModalProps> = ({ isOpen, onClose, initialValue, saving, onValidate }) => {
  const [value, setValue] = useState<PerimetreValue>(initialValue);

  useEffect(() => { if (isOpen) setValue(initialValue); }, [isOpen, initialValue]);

  useEffect(() => {
    if (!isOpen) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = prev; };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="pcarte-modal-backdrop" onClick={onClose}>
      <div className="pcarte-modal" onClick={(e) => e.stopPropagation()}>
        <header className="pcarte-modal-header">
          <div className="pcarte-modal-titles">
            <h2 className="pcarte-modal-title">Mon périmètre géographique d’achat</h2>
            <p className="pcarte-modal-subtitle">
              Sélectionnez les régions / départements de votre périmètre géographique d’achat
              sur la carte. Le tableau se met à jour en conséquence.
            </p>
          </div>
          <button className="pcarte-modal-close" onClick={onClose} aria-label="Fermer" type="button">✕</button>
        </header>

        <div className="pcarte-modal-body">
          <PerimetreSelector value={value} onChange={setValue} saving={saving} />
        </div>

        <footer className="pcarte-modal-actions">
          <button type="button" className="pcarte-modal-btn-secondary" onClick={onClose} disabled={saving}>Annuler</button>
          <button type="button" className="pcarte-modal-btn-primary" onClick={() => onValidate(value)} disabled={saving}>
            {saving ? 'Enregistrement…' : 'Valider'}
          </button>
        </footer>
      </div>
    </div>
  );
};

export default PerimetreCarteModal;
